var _rect, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMclarenBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2400,
    height: 384,
    viewBox: "0 0 2400 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_2039)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2400,
    height: 384,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_34_2039)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_34_2039",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 2400,
    height: 800
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2400 0H0V800H2400V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_34_2039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-23.5879 687.54L777.159 58.466H1268.83L300.33 819.329L-23.5879 818.53V687.54Z",
    fill: "url(#paint0_linear_34_2039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.44 -12.141L324.121 625.24H777.566L1589.9 -12.939L1135.44 -12.141Z",
    fill: "url(#paint1_linear_34_2039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.5874 513.738L368.856 205.431H748.286L-27.8574 815.176L-23.5874 513.738Z",
    fill: "url(#paint2_linear_34_2039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.018 -12.939L160.941 435.703H592.121L1165.49 -14.736L732.018 -12.939Z",
    fill: "url(#paint3_linear_34_2039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.143 -12.939L66.5928 228.674H637.67L952.26 -18.47L374.143 -12.939Z",
    fill: "url(#paint4_linear_34_2039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.799 -10.224L130.492 298.762H-178.938L219.529 -14.277L523.799 -10.224Z",
    fill: "url(#paint5_linear_34_2039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-178.938 449.84L194.608 156.38H622.622L-171.522 780.267L-178.938 449.84Z",
    fill: "url(#paint6_linear_34_2039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.674 -18.47L-78.8955 412.49H280.975L828.052 -17.297L469.674 -18.47Z",
    fill: "url(#paint7_linear_34_2039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1447.77 -14.736L1003.48 334.305H1574.65L2000.11 0.060008L1447.77 -14.736Z",
    fill: "url(#paint8_linear_34_2039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2416.47 -12.141L1719.43 535.463H1268.83L1961.1 -8.38699L2416.47 -12.141Z",
    fill: "url(#paint9_linear_34_2039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.622 815.176L1425.37 184.527H1883.73L1078.93 816.784L622.622 815.176Z",
    fill: "url(#paint10_linear_34_2039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2416.47 105.102L2086.23 364.547H1649.48L2126.82 -10.455H2416.47V105.102Z",
    fill: "url(#paint11_linear_34_2039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1766.6 -10.455L1381.28 292.257H1903.25L2291.07 -12.418L1766.6 -10.455Z",
    fill: "url(#paint12_linear_34_2039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.63 480.511H888.183L1524.97 -19.756H2000.11L1317.63 480.511Z",
    fill: "url(#paint13_linear_34_2039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2368.49 -10.455L1771.8 458.305H2248.11L2411.21 330.171L2416.47 -10.455H2368.49Z",
    fill: "url(#paint14_linear_34_2039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2413.84 159.784L1773.5 662.843H2111.47L2409.3 428.866L2413.84 159.784Z",
    fill: "url(#paint15_linear_34_2039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.85 -19.756L691.791 262.326H1158.22L1521.13 -22.778L1050.85 -19.756Z",
    fill: "url(#paint16_linear_34_2039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.5873 369.04H422.944L-34.4473 728.37L-23.5873 369.04Z",
    fill: "url(#paint17_linear_34_2039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1472.88 -10.455L1086.33 293.221H735.271L1115.67 -5.62599L1472.88 -10.455Z",
    fill: "url(#paint18_linear_34_2039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.227 -29.228L-93.7305 423.248V-26.744L482.227 -29.228Z",
    fill: "url(#paint19_linear_34_2039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.943 -121.136L-153.013 331.34V-118.652L422.943 -121.136Z",
    fill: "url(#paint20_linear_34_2039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1917.6 636.923H1589.9L2469.95 -40.036H2794.4L1917.6 636.923Z",
    fill: "url(#paint21_linear_34_2039)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M2400 0H0V800H2400V0Z",
    fill: "#F57F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M500.936 182.578C500.936 185.831 499.5 188.19 495.055 188.19H466.682C463.023 188.19 460.936 187.132 460.936 183.744C460.936 180.355 462.373 178.674 466.682 178.674H500.936V182.578ZM626.057 169.022V165.362C626.057 161.973 627.493 159.75 632.073 159.75H660.447C664.349 159.75 666.3 160.916 666.3 164.576C666.3 167.694 664.756 169.131 660.718 169.131L626.057 169.022ZM700.555 143.89V203.806H729.254V160.292H752.668C760.635 160.292 764.673 162.787 764.673 170.459V203.941H793.318V168.1C793.318 151.292 784.05 143.999 757.898 143.999L700.555 143.89ZM630.095 143.89C607.033 143.89 597.791 151.563 597.791 168.887V180.761C597.791 195.727 607.033 203.806 627.872 203.806H688.441V188.163H633.482C628.062 188.163 626.192 186.59 626.192 182.551V180.084H669.552C684.511 180.084 692.967 175.393 692.967 164.196V161.485C692.967 151.319 687.899 144.026 662.506 144.026L630.095 143.89ZM537.955 203.806H566.599V164.576C566.599 161.865 567.656 160.265 571.179 160.265H593.32V143.999H561.477C544.404 143.999 537.9 150.37 537.9 161.052L537.955 203.806ZM440.042 143.89V159.669H493.836C499.256 159.669 501.017 161.512 501.017 165.416V167.721H457.82C439.717 167.721 434.27 175.176 434.27 184.665V186.997C434.27 200.173 444.812 203.806 465.516 203.806H497.305C519.825 203.806 529.581 198.736 529.581 181.005V167.179C529.581 152.186 520.34 143.999 499.391 143.999L440.042 143.89ZM268.608 177.345C268.608 196.323 278.228 203.914 303.106 203.914H357.685V187.648H307.279C301.29 187.648 297.252 184.936 297.252 176.315V171.218C297.252 163.519 301.019 160.374 307.144 160.374H357.685V144.107H302.32C277.93 144.107 268.608 154.382 268.608 170.812V177.345ZM366.168 134.483V203.914H428.498V187.648H394.894V134.483H366.168ZM187.308 173.306V134.483H171.048C161.021 134.483 155.303 138.495 149.368 143.212L73 203.914H107.498L158.311 162.76V203.914H182.132L231.345 162.488V203.914H260.532V134.483H244.624C236.034 134.483 230.044 138.007 224.055 142.941L187.308 173.306Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M862.206 84.056C846.217 84.056 823.697 88.8276 799.28 97.7742C777.449 105.715 756.548 116.015 736.95 128.491C755.748 121.58 775.571 117.868 795.595 117.511C823.616 117.511 843.562 128.356 814.104 165.85C900.824 108.917 898.575 84.1916 862.206 84.1916",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M232.674 263.911H250.451V269.144H238.311V275.325H249.151V280.584H238.311V291.429H232.674V263.911Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M271.996 277.928V277.467C271.996 269.171 277.199 263.369 284.516 263.369C291.833 263.369 296.982 269.116 296.982 277.385V277.846C296.982 285.98 291.752 291.944 284.462 291.944C277.172 291.944 271.996 286.169 271.996 277.928ZM290.966 277.928V277.467C290.966 272.044 288.256 268.601 284.381 268.601C280.505 268.601 277.877 272.044 277.877 277.467V277.738C277.877 283.16 280.587 286.63 284.516 286.63C288.446 286.63 291.047 283.214 291.047 277.792L290.966 277.928Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M320.748 263.911H331.127C332.487 263.846 333.846 264.053 335.125 264.518C336.405 264.984 337.579 265.699 338.58 266.622C339.381 267.475 340 268.482 340.401 269.582C340.801 270.682 340.975 271.852 340.91 273.02C340.998 274.739 340.553 276.443 339.636 277.898C338.72 279.354 337.376 280.491 335.788 281.154L341.669 291.402H335.138L330.043 282.32H326.466V291.402H320.721L320.748 263.911ZM330.693 277.467C331.272 277.543 331.86 277.491 332.417 277.314C332.973 277.138 333.484 276.842 333.913 276.446C334.342 276.05 334.679 275.565 334.9 275.025C335.121 274.484 335.221 273.902 335.192 273.319C335.192 270.608 333.485 269.171 330.585 269.171H326.493V277.467H330.693Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M364.786 263.911H370.775L376.927 275.108L383.024 263.911H389.041V291.456H383.431V273.834L376.927 285.22L370.45 273.915V291.456H365.03L364.786 263.911Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M413.729 280.72V263.911H419.474V280.828C419.474 284.732 421.316 286.657 424.27 286.657C427.224 286.657 429.094 284.76 429.094 280.937V263.911H434.758V280.666C434.758 288.284 430.585 291.971 424.189 291.971C417.793 291.971 413.729 288.311 413.729 280.72Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M459.446 263.911H465.164V286.278H476.33V291.537H459.446V263.911Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M507.954 263.694H513.374L523.293 291.456H517.439L515.325 285.6H505.84L503.889 291.456H498.171L507.954 263.694ZM513.591 280.422L510.583 271.421L507.548 280.422H513.591Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M578.171 269.523L573.97 270.662L573.049 265.7L579.77 263.64H583.726V291.456H578.089L578.171 269.523Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M643.212 269.144H636.274V263.911H655.841V269.333H648.876V291.646H643.212V269.144Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M678.523 263.911H696.301V269.062H684.242V275.027H694.892V280.178H684.242V286.332H696.491V291.51H678.551L678.523 263.911Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M728.386 263.694H733.806L743.697 291.456H737.79L735.784 285.6H726.272L724.267 291.592H718.521L728.386 263.694ZM734.023 280.422L731.042 271.421L728.006 280.422H734.023Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M766.245 263.911H772.18L778.332 275.108L784.483 263.911H790.527V291.456H784.917V273.834L778.413 285.22L771.936 273.915V291.456H766.354L766.245 263.911Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34_2039",
    x1: 900.322,
    y1: 136.714,
    x2: 220.424,
    y2: 715.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_34_2039",
    x1: 1272.85,
    y1: -137.826,
    x2: 761.392,
    y2: 581.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_34_2039",
    x1: 64.8374,
    y1: 608.483,
    x2: 513.998,
    y2: 232.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_34_2039",
    x1: 276.23,
    y1: 500.058,
    x2: 646.348,
    y2: 223.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_34_2039",
    x1: 200.655,
    y1: 336.248,
    x2: 496.014,
    y2: 115.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_34_2039",
    x1: -97.0268,
    y1: 345.774,
    x2: 160.629,
    y2: 153.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_34_2039",
    x1: -214.998,
    y1: 637.815,
    x2: 132.876,
    y2: 377.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_34_2039",
    x1: 20.1713,
    y1: 462.726,
    x2: 359.101,
    y2: 209.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_34_2039",
    x1: 1141.98,
    y1: 436.034,
    x2: 1485.93,
    y2: 178.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_34_2039",
    x1: 1393.44,
    y1: 597.841,
    x2: 1823.09,
    y2: 276.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_34_2039",
    x1: 753.282,
    y1: 873.897,
    x2: 1231.38,
    y2: 516.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_34_2039",
    x1: 1757.18,
    y1: 438.419,
    x2: 2046.19,
    y2: 222.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_34_2039",
    x1: 1507.99,
    y1: 385.507,
    x2: 1821.88,
    y2: 150.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_34_2039",
    x1: 1427.62,
    y1: 156.66,
    x2: 1485.59,
    y2: 415.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_34_2039",
    x1: 2089.36,
    y1: 202.623,
    x2: 2145.8,
    y2: 454.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_34_2039",
    x1: 2283.7,
    y1: 204.309,
    x2: 2095.62,
    y2: 538.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_34_2039",
    x1: 1096.28,
    y1: 74.3577,
    x2: 1135.39,
    y2: 248.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_34_2039",
    x1: -34.4471,
    y1: 548.705,
    x2: 422.944,
    y2: 548.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_34_2039",
    x1: 1037.07,
    y1: 246.023,
    x2: 1251.65,
    y2: -89.0799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3812,
    stopColor: "#8D1B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_34_2039",
    x1: -52.7469,
    y1: 236.907,
    x2: 146.834,
    y2: 22.8643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3812,
    stopColor: "#8D1B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_34_2039",
    x1: -120.145,
    y1: 194.088,
    x2: 66.3131,
    y2: -35.3992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3812,
    stopColor: "#8D1B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_34_2039",
    x1: 2295.31,
    y1: 168.921,
    x2: 2039.11,
    y2: 490.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C0C3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5174,
    stopColor: "#B71E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15F2B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_2039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2400,
    height: 384,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_34_2039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2400,
    height: 800,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMclarenBanner);
export default __webpack_public_path__ + "static/media/mclaren_banner.3543195e908913cae4c604be23a48090.svg";
export { ForwardRef as ReactComponent };